export const navbar = {
  menuItem: {
    textTransform: "uppercase",
  },
  item: {
    textTransform: "uppercase",
  },
};
